import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {AdditionalDataType} from '../../../../../../constants/tasks';
import {AdditionalData as AdditionalDataItem} from '../../../../types';

type AdditionalDataProps = {
  additionalData: AdditionalDataItem[]
};

const AdditionalData: FC<AdditionalDataProps> = ({additionalData}) => {
  const {t} = useTranslation(['tasks']);

  if (!additionalData?.length) {
    return null;
  }

  const codeValueToLocaleText = (code) => t(`selectCodes.${code}`, code);

  const getValue = (value, type) => {
    if (type === AdditionalDataType.CODE) {
      return codeValueToLocaleText(value);
    }

    if (type === AdditionalDataType.CODES) {
      return value.split(',').map((valueCode) => codeValueToLocaleText(valueCode)).join(', ');
    }

    return value;
  };

  return (
    <section className="task-description__section">
      <h4 className="title">{t('currentTask.description.popup.additionalDataLabel')}</h4>
      <ul className="task-description__list">
        {additionalData.map(({label, value, type}, index) => {
          const result = getValue(value, type);

          return (
            <li key={`label-${index}`} className="task-description__item">
              <span>{`${label}: ${result}`}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default AdditionalData;
